import React from "react";
import * as Redux from 'react-redux';
import { Button, Modal, Message } from 'semantic-ui-react';
import * as utils from './../helpers/utils';
import $ from 'jquery';

import TopMenu from './TopMenu';
import Messages from './Messages';
import Component from './Component';
import * as configHelper from './../helpers/configHelper';
import * as landlordActions from './../actions/landlordActions';
import * as messageActions from './../actions/messageActions';
import * as displayHelper from './../helpers/displayHelper';

export class Merge extends Component {
	constructor(props) {
		super(props);
		
      this.state = {toLandlord: null, fromLandlord: null, fromRentals: [], fromBuildings: [], toRentals: [], merges: [],
         fromRentalId: null, fromBuilding: null, toBuilding: null, toBuildings: []};

      this.loadFromLandlord = this.loadFromLandlord.bind(this);
      this.loadToLandlord = this.loadToLandlord.bind(this);
      this.selectFromRental = this.selectFromRental.bind(this);
      this.selectFromBuilding = this.selectFromBuilding.bind(this);
      this.selectToBuilding = this.selectToBuilding.bind(this);
      this.handleMerge = this.handleMerge.bind(this);
      this.handleMergeAndTransfer = this.handleMergeAndTransfer.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
      this.handleConfirmTransfer = this.handleConfirmTransfer.bind(this);
      this.resetSelection = this.resetSelection.bind(this);
      this.handleConfirmMerge = this.handleConfirmMerge.bind(this);
	}

   shouldComponentUpdate(nextProps, nextState) {
		if (!super.shouldComponentUpdate(nextProps, nextState))
			return false;

		if (this.state.lastUpdate !== nextState.lastUpdate)
			return true;

		return false;
   }
    
   initialize(props, state) {
		var newState = super.initialize(props, state);
		this.setState({...state, ...newState});
	}

   handleCancel(e) {
      e.preventDefault();
      this.refs.mergeConfirmationModal.trySetState({open: false});
      this.refs.transferConfirmationModal.trySetState({open: false});
   }
    
   loadFromLandlord(e) {
      if (e)
         e.preventDefault();
		const { dispatch } = this.props;
      const fromLandlordId = this.refs.fromLandlordId.value;

      if (fromLandlordId.length === 0)
         return;

      dispatch(landlordActions.startGetLandlord(fromLandlordId, {hideError: true})).then(landlord => {
         if (this.__isCancelled)
               return;

         if (landlord) {
               if (configHelper.isInternal(landlord.source)) {
                  dispatch(landlordActions.getLandlordBuildings(fromLandlordId)).then(res => {
                     var fromBuildings = [];
                     if (res && res.buildings && res.buildings.length > 0) {
                           fromBuildings = res.buildings;
                     } 
                     !this.__isCancelled && this.setState({fromLandlord: landlord, fromBuildings, fromRentals:[], 
                        fromBuilding: null, fromRentalId: null, merges: [], lastUpdate: new Date().getTime()});	
                  });
               } else {
                  dispatch(messageActions.raiseError("The from landlord must be an internal landlord."));
               }
         } else {
               dispatch(messageActions.raiseError("Loading landlord failed."));
         }
      });
   }

   componentDidUpdate() {
      $('.ygl-table .column').popup();
   }

   loadToLandlord(e) {
      if (e)
         e.preventDefault();
      const { dispatch } = this.props;
      const toLandlordId = this.refs.toLandlordId.value;

      if (toLandlordId.length === 0)
         return;

      dispatch(landlordActions.startGetLandlord(toLandlordId, {hideError: true})).then(landlord => {
         if (this.__isCancelled)
               return;

         if (landlord) {
               if (configHelper.isDataEntry(landlord.source) || configHelper.isNetwork(landlord.source) || configHelper.isInternal(landlord.source)) {
                  dispatch(landlordActions.getLandlordBuildings(toLandlordId)).then(res => {
                     var toBuildings = [];
                     if (res && res.buildings && res.buildings.length > 0) {
                           toBuildings = res.buildings;
                     } 
                     !this.__isCancelled && this.setState({toBuildings, toRentals: [], fromRentalId: null, 
                        toBuilding: null, toLandlord: landlord, merges: [], lastUpdate: new Date().getTime()});	
                  });
               } else {
                  dispatch(messageActions.raiseError("The to landlord must be an internal, data entry or network landlord."));
               }
         } else {
               dispatch(messageActions.raiseError("Loading landlord failed."));
         }
      });
   }

   selectFromBuilding(e) {
      const {dispatch} = this.props;
      var {fromLandlord, fromRentals} = this.state;
      var fromBuilding = e.target.value;

      if (fromRentals.length === 0) {
         if (fromLandlord) {
            dispatch(landlordActions.getLandlordUnits(fromLandlord.id)).then(res => {
               fromRentals = [];
               if (res && res.units && res.units.length > 0) {
                  fromRentals = res.units;
               } 
               !this.__isCancelled && this.setState({fromBuilding, fromRentals, lastUpdate: new Date().getTime()});	
            });
         }
      } else {
         this.setState({fromBuilding, lastUpdate: new Date().getTime()});
      }
   }

   selectToBuilding(e) {
      const {dispatch} = this.props;
      var {toLandlord, toRentals} = this.state;
      var toBuilding = e.target.value;

      if (toRentals.length === 0) {
         if (toLandlord) {
            dispatch(landlordActions.getLandlordUnits(toLandlord.id)).then(res => {
               toRentals = [];
               if (res && res.units && res.units.length > 0) {
                  toRentals = res.units;
               } 
               !this.__isCancelled && this.setState({toBuilding, toRentals, lastUpdate: new Date().getTime()});	
            });
         }
      } else {
         this.setState({toBuilding, lastUpdate: new Date().getTime()});
      }
   }

   resetSelection(toRentalId) {
      console.log("resetSelection", toRentalId);
      var {merges, fromRentals} = this.state;
      
      if (merges[toRentalId]) {
         merges[toRentalId].forEach(fr => {
            $("#fromUnit" + String(fr.id)).css("display", "");
            $("#fromUnit" + String(fr.id)).removeClass("selected");
            fromRentals.push(fr)
         });
         
         merges[toRentalId] = [];
      }

      $("#mergeUnitsDisplay" + String(toRentalId)).html("");
      $("#mergeUnitsDisplay" + String(toRentalId) + "Reset").css("display", "none");
         
      this.setState({merges, fromRentals, lastUpdate: new Date().getTime()});	
   }

   selectFromRental(fromRentalId) {
      this.state.fromRentals.forEach(r => {
         if (fromRentalId === r.id)
            $("#fromUnit" + fromRentalId).addClass("selected");
         else
            $("#fromUnit" + r.id).removeClass("selected");   
      })
      
      this.setState({fromRentalId});
   }

   selectToRental(toRentalId) {
      var {fromRentalId, merges, fromRentals} = this.state;
      if (fromRentalId) {
         if (!merges[toRentalId])
            merges[toRentalId] = [];

         if (merges[toRentalId].indexOf(fromRentalId) === -1) {
            var fromRental = null;
            fromRentals.forEach(r => {
               if (r.id === fromRentalId)
                  fromRental = r;
            });
            merges[toRentalId].push(fromRental);
         }

         fromRentals = fromRentals.filter(r => {
            return r.id !== fromRentalId;
         })

         this.setState({merges, fromRentals, fromRentalId: null});	
         this.renderRentalUnits(toRentalId);
      }
   }

   getIds() {
      const {merges} = this.state;

      var idPairs = [];
      Object.keys(merges).forEach(k => {
         if (merges[k].length > 0) {
            var fids = [];
            merges[k].forEach(fr => {
               fids.push(fr.id);
            });
            idPairs.push(k + ":" + fids.join(","));
         }
      });
      var ids = idPairs.join("|");

      return ids;
   }

   handleMerge(e) {
      e.preventDefault();
      if (Object.keys(this.state.merges).length === 0) {
         alert("No unit selected.");
      } else {
         this.refs.mergeConfirmationModal.trySetState({open: true});
      }
   }

   handleConfirmMerge(e) {
      e.preventDefault();
      this.handleCancel(e);
      this.mergeAndTransfer(false);
   }

   handleMergeAndTransfer(e) {
      e.preventDefault();
      this.refs.transferConfirmationModal.trySetState({open: true});
   }

   handleConfirmTransfer(e) {
      e.preventDefault();
      this.handleCancel(e);
      this.mergeAndTransfer(true);
   }

   mergeAndTransfer(isTransfer) {
      const {dispatch} = this.props;
      var {fromBuilding, merges} = this.state;
      const fromLandlordId = this.refs.fromLandlordId.value;
      const toLandlordId = this.refs.toLandlordId.value;

      if (fromLandlordId.length === 0 || toLandlordId.length === 0)
         return;

      var ids = this.getIds();

      if ((!isTransfer && ids.length > 0) || isTransfer) {
         dispatch(landlordActions.mergeLandlordUnits(fromLandlordId, toLandlordId, ids, fromBuilding, isTransfer)).then(ok => {
               if (ok) {
                  if (isTransfer) {
                     this.loadFromLandlord();
                     this.loadToLandlord();
                  }
                  dispatch(messageActions.raiseSuccess(isTransfer ? "Units successfully merged & transferred." : "Units successfully merged."));

                  if (fromBuilding && fromBuilding.length > 0) {
                     Object.keys(merges).forEach(k => {
                        merges[k] = merges[k].filter(rental => {
                           return fromBuilding.toLowerCase() !== rental.street_number.toLowerCase() + " " + rental.street_name.toLowerCase();
                        });
                     });
                  } else {
                     merges = [];
                  }

                  this.setState({fromRentalId: null, merges, lastUpdate: new Date().getTime()});
                  $(".mergeUnitsDisplay").html("");
                  window.scrollTo(0,0);
               }
               else
                  dispatch(messageActions.raiseError("Merging units failed."));
         });
      }
   }

   renderRentalUnits(toId) {
      const { merges } = this.state;
      const mergedRentals = merges[toId];

      var adrs = "";
      if (mergedRentals && mergedRentals.length > 0) {
         adrs += "<div>To be merged:</div>";
         mergedRentals.forEach(r => {
            adrs += "<div>" + r.street_number + " " + r.street_name + (r.unit && r.unit.length > 0 ? ", #" + r.unit : "") + "</div>";
            $("#fromUnit" + r.id).css("display", "none");
         });
      }
      
      $("#mergeUnitsDisplay" + String(toId)).html(adrs);
      $("#mergeUnitsDisplay" + String(toId) + "Reset").css("display", "");
   }

	render() {
      var {config} = this.props;
      const {fromRentals, toRentals, toLandlord, fromRentalId, fromLandlord, fromBuilding, 
         toBuildings, fromBuildings} = this.state;
      
      document.title = "Merge Landlord Listings";

      return (
			<div>
				<TopMenu />
               <Messages />
               <div className="ui basic segment page-content details-page updates-page">
                  <Message header="Instructions" list={[
                     "Enter the landlord ID you want to merge units from and select a building.",
                     "Enter the landlord ID you want to move units to and select the matching building.",
                     "Choose the unit on the left that you want merged from.",
                     "Choose the unit on the right that you want to merge it into.",
                     "Use the Merge button to merge the selected units.  We recommend to merge unit in small batches instead of all at once.",
                     "Units with no matches, can be transferred over by using the Transfer button. (not available for YGL Network landlords)."
                     ]}></Message>
                  <div className="ui grid">
                     <div className="column eight wide">
                           <strong>From Landlord ID: </strong>
                           <br/>
                           <div className="ui input"><input type="text" ref="fromLandlordId" /></div> <Button onClick={this.loadFromLandlord}>Load</Button>
                           &nbsp;
                           {
                              fromBuildings.length > 0 
                                 ? <select ref="fromBuildings" className="ui normal dropdown" 
                                    defaultValue={this.state.fromBuilding} onChange={this.selectFromBuilding}>
                                    <option value="">Select Building</option>
                                    { 
                                       fromBuildings.map(building => {
                                          return <option key={building} value={building}>{building}</option>;
                                       })
                                    }
                                 </select>
                                 : ""
                           }
                           {
                              fromRentals && fromRentals.length > 0 
                                 ? <div className="ui celled grid ygl-table">
                                       <div className="sort-row row">
                                          <div className="column two wide">status</div>
                                          <div className="column three wide">city</div>
                                          <div className="column four wide">street</div>
                                          <div className="column three wide">unit</div>
                                          <div className="column two wide">beds</div>
                                          <div className="column two wide">rent</div>
                                       </div>
                                       {
                                          fromRentals.filter(rental => {
                                             if (this.state.fromBuilding && this.state.fromBuilding.length > 0) {
                                                return rental.street_number.toLowerCase() + " " + rental.street_name.toLowerCase() === this.state.fromBuilding.toLowerCase();
                                             } else {
                                                return true;
                                             }
                                          }).map(rental => {
                                             return <div key={"unit" + rental.id} id={"fromUnit" + rental.id} className={"row" + (fromRentalId === rental.id ? " selected" : "")} onClick={() => {
                                                      this.selectFromRental(rental.id);
                                                   }}>
                                                   <div className="column two wide">
                                                      <div className={configHelper.rentalStatusClass(rental)}>{utils.renderStatusIcon(rental, config)}</div>
                                                   </div>
                                                   <div className="column three wide">
                                                      { rental.neighborhood && rental.neighborhood.length > 0 ? rental.neighborhood : rental.city }
                                                   </div>
                                                   <div className="column four wide" title={rental.street_number + " " + rental.street_name}>{rental.street_number} {rental.street_name}</div>
                                                   <div className="column three wide" title={rental.unit ? "#" + rental.unit : ""}>{rental.unit ? "#" + rental.unit : ""}</div>
                                                   <div className="column two wide">{displayHelper.bedsDisplay(config, rental.beds, rental.room)}</div>
                                                   <div className="column two wide">${rental.price}</div>
                                             </div>;
                                          })
                                       }
                                 </div>
                                 : ""
                           }
                     </div>
                     <div className="column eight wide">
                        <strong>To Landlord ID: </strong>
                        <br/>
                        <div className="ui input">
                           <input type="text" ref="toLandlordId" />    
                        </div> <Button onClick={this.loadToLandlord}>Load</Button>
                        &nbsp;
                        {
                           toBuildings.length > 0 
                              ? <select ref="toBuildings" className="ui normal dropdown" 
                                 defaultValue={this.state.toBuilding} onChange={this.selectToBuilding}>
                                 <option value="">Select Building</option>
                                 { 
                                    toBuildings.map(building => {
                                       return <option key={building} value={building}>{building}</option>;
                                    })
                                 }
                              </select>
                              : ""
                        }
                        {
                           toRentals && toRentals.length > 0 
                              ? <div className="ui celled grid ygl-table">
                                    <div className="sort-row row">
                                       <div className="column two wide">status</div>
                                       <div className="column three wide">city</div>
                                       <div className="column four wide">street</div>
                                       <div className="column three wide">unit</div>
                                       <div className="column two wide">beds</div>
                                       <div className="column two wide">rent</div>
                                    </div>
                                    {
                                       toRentals.filter(rental => {
                                       if (this.state.toBuilding && this.state.toBuilding.length > 0) {
                                          return rental.street_number.toLowerCase() + " " + rental.street_name.toLowerCase() === this.state.toBuilding.toLowerCase();
                                       } else {
                                          return true;
                                       }
                                    }).map(rental => {
                                          return <div key={"unit" + rental.id} className="row" onClick={() => {
                                                this.selectToRental(rental.id);
                                          }}>
                                                <div className="column two wide">
                                                   <div className={configHelper.rentalStatusClass(rental)}>{utils.renderStatusIcon(rental, config)}</div>
                                                </div>
                                                <div className="column three wide">
                                                   { rental.neighborhood && rental.neighborhood.length > 0 ? rental.neighborhood : rental.city }
                                                </div>
                                                <div className="column four wide" title={rental.street_number + " " + rental.street_name}>{rental.street_number} {rental.street_name}</div>
                                                <div className="column three wide" title={rental.unit ? "#" + rental.unit : ""}>{rental.unit ? "#" + rental.unit : ""}</div>
                                                <div className="column two wide">{displayHelper.bedsDisplay(config, rental.beds, rental.room)}</div>
                                                <div className="column two wide">${rental.price}</div>
                                                <div id={"mergeUnitsDisplay" + rental.id} className="column sixteen wide mergeUnitsDisplay" style={{fontSize:'0.8em', fontStyle:'italic', padding: '0'}}></div>
                                                <div id={"mergeUnitsDisplay" + rental.id + "Reset"} className="column sixteen wide" style={{fontSize:'0.8em', fontStyle:'italic', padding: '0', textAlign: 'right', display: 'none'}}><a href='javascript:void(0)' onClick={(e) => {
                                                   e.preventDefault();
                                                   this.resetSelection(rental.id);
                                                }}>Reset</a></div>
                                          </div>;
                                       })
                                    }
                              </div>
                              : ""
                           }
                        </div>
                    </div>
               {
                  fromLandlord && toLandlord
                     ? <div className="actions">
                        <Button primary disabled={toLandlord && configHelper.isNetwork(toLandlord.source)} className="ui right floated" onClick={this.handleMergeAndTransfer}>Merge & Transfer Units</Button>
                        <Button primary className="ui right floated" onClick={this.handleMerge}>Merge Units</Button>
                        <Modal ref="transferConfirmationModal" size="small" closeIcon>
                           <Modal.Header>
                              {
                                 fromBuilding && fromBuilding.length > 0
                                    ? "Merge & Transfer Units In " + fromBuilding + "?"
                                    : "Merge & Transfer Units?"
                              }
                           </Modal.Header>
                           <Modal.Content>
                              {
                                 fromBuilding && fromBuilding.length > 0
                                    ? "Selected units in " + fromBuilding + " will be merged. The remaining unselected units in " + fromBuilding + " will be transferred to the To Landlord."
                                    : "Selected units will be merged. The remaining unselected units will be transferred to the To Landlord."
                              }                                 
                              <br/>
                              <Message error>This action cannot be reversed, are you sure you want to continue?</Message>
                           </Modal.Content>
                           <Modal.Actions>
                                 <Button secondary onClick={this.handleCancel}>Cancel</Button>
                                 <Button primary onClick={this.handleConfirmTransfer}>OK</Button>
                           </Modal.Actions>
                        </Modal>
                        <Modal ref="mergeConfirmationModal" size="small" closeIcon>
                           <Modal.Header>
                              {
                                 fromBuilding && fromBuilding.length > 0
                                    ? "Merge Units in " + fromBuilding + "?"
                                    : "Merge Units?"
                              }
                                 
                           </Modal.Header>
                           <Modal.Content>
                              {
                                 fromBuilding && fromBuilding.length > 0
                                    ? "All selected units in " + fromBuilding + " will be merged."
                                    : "All selected units will be merged."
                              }
                              <br/>
                              <Message error>This action cannot be reversed, are you sure you want to continue?</Message>
                           </Modal.Content>
                           <Modal.Actions>
                                 <Button secondary onClick={this.handleCancel}>Cancel</Button>
                                 <Button primary onClick={this.handleConfirmMerge}>OK</Button>
                           </Modal.Actions>
                        </Modal>
                     </div>
                     : ""
               }
            </div>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Merge);


// WEBPACK FOOTER //
// ./src/components/Merge.js